import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ENQUIRY_ID } from "../../data/holidays";
import { useHolidayScroll, EASE } from "./shared";
import { useEarlyBird } from "../../lib/useEarlyBird";

// Mobile-only sticky price + CTA bar. Hidden while the hero or the form is on screen.
export default function HolidayStickyBar() {
  const { t } = useTranslation();
  const scrollTo = useHolidayScroll();
  const [visible, setVisible] = useState(false);
  const eb = useEarlyBird();

  useEffect(() => {
    const hero = document.querySelector('[data-testid="holidays-hero"]');
    const form = document.getElementById(ENQUIRY_ID);
    if (!hero || !form) return;
    const state = { hero: true, form: false };
    const update = () => setVisible(!state.hero && !state.form);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.target === hero) state.hero = en.isIntersecting;
        if (en.target === form) state.form = en.isIntersecting;
      });
      update();
    }, { threshold: 0.05 });
    io.observe(hero); io.observe(form);
    return () => io.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="holidays-sticky-bar"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: EASE }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-forest text-bone border-t border-bone/15 px-5 py-3 flex items-center justify-between gap-4 shadow-[0_-8px_30px_rgba(0,0,0,0.25)]"
          style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
        >
          <div>
            <div className="font-display text-2xl leading-none">{t("holidays.sticky.from")}</div>
            <div className="text-[10px] uppercase tracking-wider-2 text-bone/60 mt-1">{eb.active ? t("holidays.sticky.sub") : t("holidays.hero.facts.duration")}</div>
          </div>
          <button
            type="button"
            onClick={() => scrollTo(ENQUIRY_ID)}
            data-testid="sticky-cta"
            className="inline-flex items-center gap-2 bg-bone text-forest px-5 py-3 min-h-[44px] text-xs uppercase tracking-wider-3"
          >
            {t("holidays.sticky.cta")} <ArrowUpRight className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
